import { Injectable, Injector, TemplateRef, Type } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DcModalComponent } from './dc-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(public ngbModal: NgbModal) {}

  openDialog(props: any, template?: TemplateRef<any>, customInjector?: Injector): Promise<any> {
    const modalRef = this.ngbModal.open(template || DcModalComponent, {
      size: props.size,
      backdrop: props.backdrop,
      centered: true,
      injector: customInjector
    });
    modalRef.componentInstance?.setDialogProps(props);
    return modalRef.result;
  }

  openModal(props: any, template: TemplateRef<any> | Type<any>, customInjector?: Injector): NgbModalRef {
    const modalRef = this.ngbModal.open(template, {
      size: props?.size || 'lg',
      backdrop: props?.backdrop || 'static',
      centered: true,
      fullscreen: props?.fullscreen || false,
      windowClass: props?.windowClass || '',
      injector: customInjector
    });

    modalRef.componentInstance?.setDialogProps?.(props);
    return modalRef;
  }

  close(): void {
    this.ngbModal.dismissAll();
  }
}
